// extracted by mini-css-extract-plugin
export default {"menuBlock":"iE-z","title":"jE-z","nav":"kE-z","flexCell":"lE-z","facetLink":"mE-z"};